export default "__VITE_ASSET__DQ_InOzD__"